import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,
	state: {
		albums: []
	},

	actions: {
		fetchAll ({ commit }) {
			return axios.get('/albums').then((response) => {
				commit(types.STORE_ALBUMS, response.data)
				return response.data
			})
		},

		fetch ({ commit }, { id }) {
			return axios.get(`/albums/${id}`).then((response) => {
				commit(types.STORE_ONE_ALBUM, response.data)
			})
		}
	},

	mutations: {
		[types.STORE_ALBUMS] (state, albums) {
			state.albums = albums
		}
	},

	getters: {
		getById: (state) => (id) => state.albums.find((t) => t.id === id)
	}
}
